import type { Blank } from 'store/types/common';

import { ESTIMATE } from '../constants';

import { ClientBlankEstimateActions } from './client-blank-estimate-actions';
import { ClientBlankEstimateSchedule } from './client-blank-estimate-schedule';
import { ClientBlankEstimateList, ClientBlankEstimateTable } from './client-blank-estimate-table';
import { useMediaQuery } from '@mui/material';
import styles from './styles.module.scss';

interface ClientBlankEstimateProps {
	data: Blank;
	onAdd: () => void;
	isMobile: any;
}

export const ClientBlankEstimate = ({ data, onAdd, isMobile }: ClientBlankEstimateProps) => {
	const isAdaptive = useMediaQuery('(max-width: 768px)');

	return (
		<>
			{isAdaptive ? (
				<div className={styles.estimate}>
					<div className={styles.estimate__title}>
						<h3>{ESTIMATE}</h3>
					</div>

					<ClientBlankEstimateSchedule data={data} />
					<div className={styles.blank_table}>
						{isMobile ? <ClientBlankEstimateList data={data} /> : <ClientBlankEstimateTable data={data} />}
					</div>
					<div className={styles.estimate__actions_container}>
						<ClientBlankEstimateActions onAdd={onAdd} isAdaptive={isAdaptive} isMobile={isMobile} />
					</div>
				</div>
			) : (
				<div className={styles.estimate}>
					<div className={styles.estimate__title}>
						<h3>{ESTIMATE}</h3>

						<ClientBlankEstimateActions onAdd={onAdd} />
					</div>

					<ClientBlankEstimateSchedule data={data} />
					<div className={styles.blank_table}>
						<ClientBlankEstimateTable data={data} />
					</div>
				</div>
			)}
		</>
	);
};
